<template>
  <vx-card class="mb-base" :title="$t('class-overview.assessment')" title-color="primary">
    <li class="flex flex-inline justify-between w-full">
      <div class="flex-1">
        <vs-chip class="cursor-pointer w-3/5" color="primary" transparent>
          {{ $t('class-overview.assessment-short') }}
        </vs-chip>
      </div>
      <div>
        <vs-chip class="cursor-pointer" color="primary" transparent>
          {{ $t('class-overview.percent-text') }}
        </vs-chip>
        <vs-chip class="cursor-pointer" color="primary" transparent>
          {{ $t('class-overview.score') }}
        </vs-chip>
      </div>
    </li>
    <li
      v-for="(assessment, index) in courseOutlineAssessments"
      :key="assessment.id + '_' + index" class="flex flex-inline justify-between items-center w-full px-3 pl-0"
    >
      <div class="flex-1 flex justify-start items-start">
        <vs-avatar :text="`${assessment.seq}`" class="bg-primary w-5 h-5 text-sm mr-2 p-2"/>
        <span class="text-sm mt-1">
          {{ assessment.assessment.nameLocal }}
        </span>
      </div>
      <div class="flex w-30 justify-between">
        <span class="w-16 text-right"> {{ assessment.percent }} </span>
        <span class="w-16 text-right"> {{ assessment.score }} </span>
      </div>
    </li>
  </vx-card>
</template>

<script>
export default {
  name: "AssessmentInfo",
  props: ['courseOutlineAssessments']
}
</script>

<style scoped>

</style>
